<template>
  <v-form
    id="forgotPasswordForm"
    ref="forgotPasswordForm"
  >
    <v-card-text>
      <PolteqTextField
        v-model="emailaddress"
        field-id="usernameField"
        :label="i18n.t('fields.emailaddress')"
        :rules="[rules.email]"
        type="email"
        autocomplete="username"
        icon="mdi-email-outline"
        @keyup.enter="resetPassword(emailaddress)"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="resetPasswordButton"
        icon="mdi-email-arrow-right-outline"
        :button-text="i18n.t('buttons.resetpassword')"
        @click="resetPassword(emailaddress)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./ForgotPasswordForm.ts" />
